import { getLastPageNumber } from './get-last-page-number';

export const enableOrDisablePaginationButtons = (newPage: number, listWrapperRootElement: HTMLElement) => {
    const { firstPageButton, previousPageButton, nextPageButton, lastPageButton } = findButtons(listWrapperRootElement);
    if (!firstPageButton || !previousPageButton || !nextPageButton || !lastPageButton) return;
    const isFirstPage = newPage === 1;
    const isLastPage = newPage === getLastPageNumber(listWrapperRootElement);
    if (isFirstPage) {
        disableButton(firstPageButton);
        disableButton(previousPageButton);
    } else {
        enableButton(firstPageButton);
        enableButton(previousPageButton);
    }
    if (isLastPage) {
        disableButton(nextPageButton);
        disableButton(lastPageButton);
    } else {
        enableButton(nextPageButton);
        enableButton(lastPageButton);
    }
};

const findButtons = (listWrapperRootElement: HTMLElement) => {
    const firstPageButton = listWrapperRootElement.querySelector<HTMLButtonElement>('.js_cr_list-wrapper__pagination-button-first');
    const previousPageButton = listWrapperRootElement.querySelector<HTMLButtonElement>('.js_cr_list-wrapper__pagination-button-previous');
    const nextPageButton = listWrapperRootElement.querySelector<HTMLButtonElement>('.js_cr_list-wrapper__pagination-button-next');
    const lastPageButton = listWrapperRootElement.querySelector<HTMLButtonElement>('.js_cr_list-wrapper__pagination-button-last');
    return { firstPageButton, previousPageButton, nextPageButton, lastPageButton };
};

const disableButton = (button: HTMLButtonElement) => {
    button.setAttribute('disabled', '');
};

const enableButton = (button: HTMLButtonElement) => {
    button.removeAttribute('disabled');
};
